import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';

import { VideaButton } from '../../../common-components/elements/VideaButton/VideaButton';
import { VideaTypography } from '../../../common-components/elements/VideaTypography/VideaTypography';
import { useGetInsightsSummary } from '../../../react-query/useGetInsightsSummary';
import { useGetPractice } from '../../../react-query/useGetPractice';
import { usePreferences } from '../../../react-query/usePreferences';
import routesConstants from '../../../routes/routes.constants';
import {
  blueBlack640,
  green400,
  greyLight400,
} from '../../../theme/videa-style-tokens';
import { getFirstDateOfMonth } from '../../../utils/date.util';
import OverallPerformance from '../common/overallPerformance/OverallPerformance';
import { FINE_PRINT } from '../constants';

const date = new Date();
const currentMonth = date.toLocaleString('default', { month: 'long' });
const currentYear = date.getFullYear();

const InsightsContainer = styled.div`
  position: relative;

  .info {
    margin: 1.5em 0 2em;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .title {
    color: ${blueBlack640};
    font-weight: 500;
  }
  .period {
    margin: 0 0.5em;
    font-size: 1.5em;
    font-weight: 400;
    color: ${blueBlack640};
  }
  .header: {
    color: ${greyLight400};
    font-size: 1em;
  }
  .fine-print {
    position: absolute;
    right: 0;
    top: 0;
    width: 12em;
    height: 1.5em;
    font-size: 0.75em;
    color: ${green400};
    line-height: 1;
    text-align: right;
  }
  .button {
    margin: 0 0 0 2em;
  }
`;

const LocationDetails = () => {
  const { id: practiceId } = useParams<{ id: string }>();
  const user = useSelector((state: any) => state?.login?.user);
  const { data: prefs } = usePreferences();

  const { data: location } = useGetInsightsSummary({
    organizationId: user.primaryOrganizationId,
    startDate: getFirstDateOfMonth(),
    endDate: date.toISOString(),
    practiceId: practiceId,
  });

  const { data: findOne } = useGetPractice({
    organizationId: user.primaryOrganizationId,
    practiceId: practiceId,
  });

  const practiceInfo = findOne?.practice;

  return (
    <InsightsContainer>
      <div className="info">
        <VideaTypography variant="headingSmall" className="title">
          {!!practiceInfo && practiceInfo?.name}
        </VideaTypography>
        <VideaTypography
          variant="headingSmall"
          className="period"
        >{`${currentMonth} ${currentYear}`}</VideaTypography>
        <VideaButton
          component={Link}
          to={
            // If standaloneClaimsEnabled is true, redirect to claims instead of huddle
            prefs?.standaloneClaimsEnabled && prefs?.cleanClaims
              ? `${routesConstants.CLAIMS}?director_view_practice_id=${practiceInfo?.id}`
              : `${routesConstants.UPLOADER}?director_view_practice_id=${practiceInfo?.id}`
          }
          target="_blank"
          className="button"
        >
          Review Patient AI Findings
        </VideaButton>
        <div className="fine-print">{FINE_PRINT}</div>
      </div>
      <OverallPerformance insights={location} />
    </InsightsContainer>
  );
};

export default LocationDetails;
